module.exports = __webpack_public_path__ + "assets/list-item.a52775cf.svg";